import PagePlaceholder from "../components/PagePlaceholder";

/**
 * The Scorecards view. Placeholder until the domain model is defined.
 */
function Scorecards() {
  return (
    <PagePlaceholder
      title="Scorecards"
      summary="Placeholder. Scorecard content is not defined yet — this view is a stand-in until the domain model lands."
    />
  );
}

export default Scorecards;
